import { settled } from 'common/types/Event-type.type';

export const EVENTS_TO_REFETCH_PROFILE_SKILLS = [
  settled('AspirationAdded'),
  settled('AspirationDeleted'),
  settled('EndorsedSkillAdded'),
  settled('EndorsedSkillDeleted'),
];
